<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { Container, Text, Button, Stack, Alert, Modal } from '@Shelly/shelly-design-system';
	//Components
	import DoubleTimePicker from '../../../../TimePicker/DoubleTimePicker.svelte';
	import DayPicker from '../../../../TimePicker/DayPicker.svelte';
	//Helpers
	import { capFirstChar, deepCopy } from '../../../../../helpers/utilities';
	import {
		findEmptyInterval,
		timeToInterval,
		isValidIntervals,
	} from '../../../helpers/intervals_helpers';
	//Types
	import type {
		IChartTempSchedule,
		ITempSchemeObj,
		TempScheduleInterval,
	} from 'src/types/TemperatureSchemeType';
	import ChooseTempAndState from './ChooseTempAndState.svelte';

	export let intervalID: number, data: IChartTempSchedule, temp_scheme_object: ITempSchemeObj;

	const copyData = deepCopy(data);
	const dispatch = createEventDispatcher();
	let interval: TempScheduleInterval = copyData.intervals[intervalID];
	if (!interval) {
		interval = findEmptyInterval(copyData.intervals, copyData.base);
		copyData.intervals.push(interval);
	}

	const onTempChange = (e: CustomEvent) => {
		let { min = 4, max = 34 } = temp_scheme_object?._meta?.[copyData.units]?.[copyData.type];
		interval.base = Math.min(max, Math.max(min, e.detail.value));
	};

	const onDaysChanges = (e: CustomEvent) => {
		interval.days = e.detail.map((i: number) => (i = i == 6 ? 0 : i + 1));
		onIntervalChanges();
	};

	const onTimeChanges = (e: CustomEvent) => {
		interval.time = e.detail;
		interval.dur = timeToInterval(e.detail).dur;
		onIntervalChanges();
	};

	const onIntervalChanges = () => {
		if (interval.days.length == 0) {
			notSelectedWeekday = true;
			return;
		}
		notSelectedWeekday = false;
		invalidIntervals = !isValidIntervals(copyData.intervals);
	};

	const onSave = () => {
		dispatch('save', { interval });
	};

	const onEnableChange = (e) => {
		interval.disabled = e.detail.disabled;
	};

	const days = interval.days.map((i: number) => (i = i == 0 ? 6 : i - 1));

	let invalidIntervals = false;
	let notSelectedWeekday = false;
	onIntervalChanges();
</script>

<Modal
	on:close={() => {
		dispatch('cancel');
	}}
	title={capFirstChar($format('specific_interval'))}
	showModal
	backdropClose={false}
>
	<Container fullHeight slot="content" padding="0">
		<Text element="h2" class="mb-s">
			{$format('choose_day_of_week', { default: 'Choose day(s) of the week' })}
		</Text>
		<DayPicker class="mb-m" {days} on:change={onDaysChanges} />

		<Text element="h2" class="mb-s">
			{$format('choose_time_interval', { default: 'Choose interval' })}
		</Text>
		<DoubleTimePicker class="mb-s" time={interval.time} on:change={onTimeChanges} />

		<Alert
			class="mb-m"
			type={invalidIntervals || notSelectedWeekday ? 'danger' : 'success'}
			heading={notSelectedWeekday
				? $format('schedule_creation_info', {
						default: 'Please select at least one day!',
					})
				: invalidIntervals
					? $format('alert_error_interval_overlap')
					: $format('alert_valid_interval', {
							default: 'Valid interval',
						})}
			isHeadingBold
		/>

		<ChooseTempAndState
			units={copyData.units}
			value={interval.base}
			mode={copyData.type}
			disabled={interval.disabled}
			on:change_thermostat_state={onEnableChange}
			on:temp_change={onTempChange}
		/>
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		<Button
			variant="secondary"
			class="mr-s min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				dispatch('cancel');
			}}
		>
			{$format('button_cancel')}
		</Button>

		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			disabled={invalidIntervals || notSelectedWeekday}
			on:click={onSave}
		>
			{$format('button_save_type', {
				values: { type: $format('process_interval') },
			})}
		</Button>
	</div>
</Modal>
